import React from 'react';

/**
 * Parses markdown style links into jsx links
 * Would use a package but right now we just want one feature: links.
 */
const linkRegexGlobal = /\[.*?\]\(.+?\)/g; // matches [copy](link)
const linkCaptureRegex = /\[(.*?)\]\((.+?)\)/;
const SPLIT_CHAR = '%%&&';

const generateLink = (returnAsString) => (potentialLink, index) => {
  const matchResult = potentialLink.match(linkCaptureRegex); // yields [matched, copy, link]

  if (matchResult) {
    const copy = matchResult[1];
    const link = matchResult[2];
    const isAnchor = link[0] === '#';
    const target = isAnchor ? undefined : '_blank';

    return returnAsString ? (
      `<a href="${link}" target="${target}">${copy}</a>`
    ) : (
      <a href={link} key={`link-${index}`} target={target}>
        {copy}
      </a>
    );
  }

  // This is not a link
  return potentialLink;
};

export default (content, returnAsString = false) => {
  if (typeof content === 'string') {
    // Wrap all links in a split character
    const bookmarkedString = content.replace(
      linkRegexGlobal,
      (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
    );

    // Split on split char and map everything you can to links
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateLink(returnAsString));
    return returnAsString ? result.join(' ') : result;
  }

  // This is not parsable
  return content;
};
